/**
 * Footer copy and navigation — mirrors main site routes from gatsby-config.
 * @param {boolean} isEn
 */
export const getFooterContent = isEn => ({
  cta: {
    title: isEn
      ? 'Are you ready\nto create something impactful?'
      : 'Preparado para criar\nalgo com impacto?',
    description: isEn
      ? 'We are a tech partner founded in 2001, and we continuously reinvent ourselves to add value to our clients\' businesses through impactful technology.'
      : 'Fundada em 2001, a log é um parceiro tecnológico que se reinventa constantemente para agregar valor aos negócios dos seus clientes através de tecnologia de impacto.',
    linkLabel: isEn ? 'Lets Talk' : 'Contacte-nos',
    linkTo: isEn ? '/en/contact-us/' : '/contacte-nos/',
  },
  services: {
    label: isEn ? 'Services' : 'Serviços',
    items: isEn
      ? [
          {
            label: 'Application Development & Modernization',
            href: '/en/application-development-modernization/',
          },
          { label: 'Data & AI', href: '/en/data-ai/' },
          {
            label: 'Cloud & Infrastructure',
            href: '/en/cloud-infrastructure/',
          },
          { label: 'Cyber Security', href: '/en/cyber-security/' },
        ]
      : [
          {
            label: 'Desenvolvimento e Modernização de Aplicações',
            href: '/desenvolvimento-modernizacao-aplicacoes/',
          },
          { label: 'Dados & IA', href: '/dados-ia/' },
          {
            label: 'Cloud & Infraestrutura',
            href: '/cloud-infraestrutura/',
          },
          { label: 'Cibersegurança', href: '/ciberseguranca/' },
        ],
  },
  primaryLinks: isEn
    ? [
        { label: 'Work', href: '/en/work/' },
        { label: 'Toolbox', href: '/en/toolbox/' },
        { label: 'About Us', href: '/en/about-us/' },
      ]
    : [
        { label: 'Trabalho', href: '/trabalho/' },
        { label: 'Ferramentas', href: '/ferramentas/' },
        { label: 'Sobre Nós', href: '/sobre-nos/' },
      ],
  contact: {
    email: 'hello@log.pt',
    emailHref: 'mailto:hello@log.pt',
    addressLine1: 'Alameda António Sérgio 22 1º B,',
    addressLine2: 'Miraflores, 1495-132 Algés',
    linkedin: {
      href: 'https://www.linkedin.com/company/log-impactful-tech-solutions/',
      label: 'log on LinkedIn',
    },
  },
  legal: {
    cookieLabel: isEn ? 'Cookie Settings' : 'Definições de Cookies',
    esg: isEn
      ? { label: 'ESG Strategy', href: '/en/strategy-ESG/' }
      : { label: 'Estratégia ESG', href: '/estrategia-ESG/' },
    logAi: { label: 'log.AI', href: isEn ? '/en/log-ai/' : '/log-ai/' },
    copyright: isEn
      ? 'Copyright log. All rights reserved.'
      : 'Copyright log. Todos os direitos reservados.',
  },
})
